import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
	InputAdornment,
	MenuItem,
	SelectChangeEvent,
	Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Ticker } from "../../_app/types";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {SelectStyled, TextFieldStyled} from "../../components/ui/StyledAdron";
import CurrencyCard from "../../_pages/TickerChoosePage/components/CurrencyCard";

interface Props {
	tickers: Ticker[];
	quote: string;
	base: string;
	onChange: (event: SelectChangeEvent<any>) => void;
}

const TickerSelect = ({ tickers, quote, base, onChange }: Props) => {
	const theme = useTheme();

	const [searchValue, setSearchValue] = React.useState<string>("");

	const filteredTickers = React.useMemo(
		() => tickers.filter((ticker) => ticker.base.toLowerCase().includes(searchValue.toLowerCase())),
		[tickers, searchValue]
	);

	const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		event.preventDefault();
		setSearchValue(event.target.value);
	};

	const renderCurrencyValue = (selected: unknown): React.ReactNode => {
		const value = selected as string;
		return (
			<Typography
				sx={{ fontWeight: 600 }}
				color={"textSecondary"}
			>{`${value}/${quote}`}</Typography>
		);
	};

	return (
		<SelectStyled
			disabled={true}
			sx={{ fontWeight: "900" }}
			fullWidth={true}
			size={"small"}
			value={base}
			label=""
			autoComplete={"off"}
			onChange={onChange}
			IconComponent={KeyboardArrowDownIcon}
			renderValue={renderCurrencyValue}
			MenuProps={{
				autoFocus: false,
				PaperProps: {
					sx: {
						backgroundImage: "none",
						backgroundColor: theme.palette.grey[500], // Замените на нужный цвет
						border: `1px solid ${theme.palette.grey[300]}`,
						boxShadow: "0px -4px 6px -1px rgba(0, 0, 0, 0.1)",
						maxHeight: "300px",
						overflowY: "auto",
					},
				},
				onClick: (e) => e.stopPropagation(),
				MenuListProps: {
					autoFocus: false,
					sx: {
						paddingTop: 0,
						paddingBottom: 0,
					},
				},
			}}
		>
			<div style={{ padding: "6px 8px" }}>
				<TextFieldStyled
					fullWidth
					variant="outlined"
					size="small"
					placeholder="Search"
					value={searchValue}
					autoComplete={"off"}
					onChange={handleSearchChange}
					InputProps={{
						endAdornment: (
							<InputAdornment position="start">
								<SearchOutlinedIcon />
							</InputAdornment>
						),
						autoComplete: "off",
						sx: {
							borderRadius: "12px !important",
						},
					}}
				/>
			</div>
			{filteredTickers.map((ticker: Ticker, index: number) => (
				<MenuItem key={index} value={ticker.base}>
					<CurrencyCard ticker={ticker} fullWidth />
				</MenuItem>
			))}
		</SelectStyled>
	);
};

export default TickerSelect;
